import { get } from 'common/api';

export const getProductsStats = params => get('/v5/stats/products', params);

export const getBillingStats = params => get('/v5/stats/billing', params);
